import React, { useState } from "react";
import { useParams } from "react-router-dom";
import {
  Button,
  Paper,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
} from "@mui/material";
import useCaseList from "../../../hooks/useCaseList.js";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";
import { caseNegotiationsTable } from "../../../config/grid-column-defs";
import { useSelector } from "react-redux";
import {
  addNewNegotiation,
  getCaseNegotiations,
} from "../../../api/caseNegotiations";
import useSnackbar from "../../../hooks/useSnackbar.js";
import ConditionalRenderer from "../../../components/ConditionalRenderer.jsx";
import useErrorHandler from "../../../hooks/useErrorHandler.js";

export default function CaseNegotiations() {
  // return <></>
  const params = useParams();
  const { data: user } = useSelector((state) => state.user);
  const errorHandler = useErrorHandler();
  const [negotiationTableRefreshCount, setNegotiationTableRefreshCount] =
    useState(0);
  function refreshTable() {
    setNegotiationTableRefreshCount((prev) => prev + 1);
  }

  const { selectedCaseName, setSelectedCaseId } = useCaseList();
  setSelectedCaseId(params.id);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [isPrimary, setIsPrimary] = useState(false);

  async function getNegotiationTableData(limit, offset) {
    try {
      const { data } = await getCaseNegotiations(user.token, params.id, {
        limit,
        offset,
      });
      setIsPrimary(data.primary);
      return { rows: data.data, total: data.total, error: false };
    } catch (error) {
      errorHandler(error);
      return { error: true };
    } finally {
      // setLoading(false);
    }
  }

  const snackbar = useSnackbar();
  async function onAddDone(error = false) {
    if (error) {
      snackbar.showError();
    } else {
      snackbar.showSuccess("Negotiation Added.");
      refreshTable();
    }
  }

  return (
    <>
      <Paper className="odr-card">
        <ConditionalRenderer show={/true/.test(isPrimary)}>
          <Box>
            <Box p={2} display="flex" justifyContent="space-between">
              <Box>
                Negotiations for case <b>{selectedCaseName}</b>
              </Box>
              <Box display="flex" justifyContent="flex-end" columnGap={2}>
                <Button
                  variant="contained"
                  size="small"
                  color="primary"
                  onClick={() => {
                    setDialogOpen(true);
                  }}
                >
                  Add New
                </Button>
              </Box>
            </Box>
          </Box>
        </ConditionalRenderer>

        <Box className="odr-main-table" pt={1}>
          <AgGridPaginatedTable
            columns={caseNegotiationsTable}
            getTableRows={getNegotiationTableData}
            refreshCounter={negotiationTableRefreshCount}
          />
        </Box>
      </Paper>
      <AddNewDialog
        open={dialogOpen}
        setOpen={setDialogOpen}
        onAddDone={onAddDone}
        token={user.token}
        caseId={params.id}
      />
    </>
  );
}

const emptyData = {
  title: "",
  description: "",
  amount: 0,
};
function AddNewDialog({ open = true, setOpen, onAddDone, token, caseId }) {
  const [data, setData] = useState(emptyData);
  const errorHandler = useErrorHandler();
  const handleInputChange = ({ target }) => {
    const { value, name } = target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleClose = () => {
    setOpen(false);
  };

  async function handleFormSubmit(e) {
    e.preventDefault();
    try {
      await addNewNegotiation(token, caseId, data);
      onAddDone();
    } catch (error) {
      errorHandler(error);
      onAddDone(true);
    } finally {
      setOpen(false);
    }
  }

  return (
    <Dialog
      open={open}
      //onClose={handleClose}
      onClose={() => {       
      }}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle className="heading-title">Create</DialogTitle>
      <DialogContent>
        <Box component="form" pt={1} onSubmit={handleFormSubmit}>
          <Grid container spacing={1}>
            <Grid item md={6} xl={6}>
              <TextField
                name="title"
                size="small"
                fullWidth
                required
                onChange={handleInputChange}
                value={data.title}
                label="Title"
              />
            </Grid>
            <Grid item md={6} xl={6}>
              {/* <Box display='flex'> */}
              {/* <Slider value={data.amount} onChange={handleInputChange} name="amount" /> */}
              <TextField
                type="number"
                name="amount"
                size="small"
                fullWidth
                required
                onChange={handleInputChange}
                value={data.amount}
                inputProps={{ min: 0 }}
                label="Amount($)"
              />
              {/* </Box> */}
            </Grid>
            <Grid item md={12} xl={12}>
              <TextField
                name="description"
                size="small"
                fullWidth
                required
                onChange={handleInputChange}
                value={data.description}
                label="Description"
              />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          size="large"
          onClick={handleClose}
          className="black-border-button"
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          size="large"
          className="blue-button"
          onClick={handleFormSubmit}
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
}
